// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, ui-sans-serif, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, ui-monospace, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.bef-card {
  overflow: hidden;
  border-radius: 1.125rem;
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 10px 30px -8px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 10px 30px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: 0 10px 30px -8px rgba(15, 23, 42, 0.12);
    border-color: var(--border);
}
.bef-btn-primary {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 1.125rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(17 69 152 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
@media (min-width: 640px) {

  .bef-btn-primary {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.bef-btn-primary:hover:not(:disabled) {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    background-color: #0d3678;
    border-color: #0d3678;
}
.bef-btn-primary:disabled,
  .bef-btn-primary[disabled] {
  pointer-events: none;
  transform: none;
  cursor: not-allowed;
  opacity: 0.8;
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
    color: #ffffff !important;
}
.bef-btn-secondary {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 1.125rem;
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(17 69 152 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
@media (min-width: 640px) {

  .bef-btn-secondary {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.bef-btn-secondary:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.bef-input {
  width: 100%;
  border-radius: 1.125rem;
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(20 33 61 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
    border-color: var(--border);
}
.bef-input:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(17, 69, 152, 0.12);
  }
.bef-label {
  margin-bottom: 0.25rem;
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(20 33 61 / var(--tw-text-opacity, 1));
}
.bef-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 9px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  --tw-text-opacity: 1;
  color: rgb(17 69 152 / var(--tw-text-opacity, 1));
}
.bef-table-wrap {
  width: 100%;
  overflow-x: auto;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-20 {
  bottom: -5rem;
}
.-left-20 {
  left: -5rem;
}
.-right-16 {
  right: -4rem;
}
.-top-16 {
  top: -4rem;
}
.bottom-1 {
  bottom: 0.25rem;
}
.end-0 {
  inset-inline-end: 0px;
}
.left-0 {
  left: 0px;
}
.left-3 {
  left: 0.75rem;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.top-0 {
  top: 0px;
}
.top-14 {
  top: 3.5rem;
}
.top-16 {
  top: 4rem;
}
.top-2 {
  top: 0.5rem;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.-m-4 {
  margin: -1rem;
}
.-m-5 {
  margin: -1.25rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mt-5 {
  margin-top: -1.25rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.me-3 {
  margin-inline-end: 0.75rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[0\\.3rem\\] {
  margin-top: 0.3rem;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/8\\] {
  aspect-ratio: 16/8;
}
.size-12 {
  width: 3rem;
  height: 3rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[94vh\\] {
  height: 94vh;
}
.h-\\[calc\\(100dvh-7rem\\)\\] {
  height: calc(100dvh - 7rem);
}
.h-\\[calc\\(100vh-250px\\)\\] {
  height: calc(100vh - 250px);
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-16 {
  max-height: 4rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-\\[450px\\] {
  max-height: 450px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[600px\\] {
  max-height: 600px;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[calc\\(100dvh-2rem\\)\\] {
  max-height: calc(100dvh - 2rem);
}
.max-h-\\[calc\\(100vh-4rem\\)\\] {
  max-height: calc(100vh - 4rem);
}
.\\!min-h-\\[3rem\\] {
  min-height: 3rem !important;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-11 {
  min-height: 2.75rem;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[2\\.75rem\\] {
  min-height: 2.75rem;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[calc\\(100vh-4rem\\)\\] {
  min-height: calc(100vh - 4rem);
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[85vw\\] {
  width: 85vw;
}
.w-\\[calc\\(100\\%-100px\\)\\] {
  width: calc(100% - 100px);
}
.w-\\[calc\\(100vw-5rem\\)\\] {
  width: calc(100vw - 5rem);
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[2\\.25rem\\] {
  min-width: 2.25rem;
}
.min-w-\\[2\\.75rem\\] {
  min-width: 2.75rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-16 {
  max-width: 4rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[288px\\] {
  max-width: 288px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[7rem\\] {
  max-width: 7rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.table-auto {
  table-layout: auto;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-8 {
  --tw-translate-x: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(227 233 242 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.text-balance {
  text-wrap: balance;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[0\\.4375rem\\] {
  border-radius: 0.4375rem;
}
.rounded-\\[36px\\] {
  border-radius: 36px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.75rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 1.125rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 1.125rem;
  border-bottom-left-radius: 1.125rem;
}
.rounded-e-xl {
  border-start-end-radius: 1.125rem;
  border-end-end-radius: 1.125rem;
}
.rounded-r-xl {
  border-top-right-radius: 1.125rem;
  border-bottom-right-radius: 1.125rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-t-xl {
  border-top-left-radius: 1.125rem;
  border-top-right-radius: 1.125rem;
}
.rounded-br-\\[18px\\] {
  border-bottom-right-radius: 18px;
}
.rounded-tr-\\[18px\\] {
  border-top-right-radius: 18px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-8 {
  border-width: 8px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-primary {
  --tw-border-opacity: 1 !important;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#114598\\] {
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BBF7D0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-border {
  --tw-border-opacity: 1;
  border-color: rgb(227 233 242 / var(--tw-border-opacity, 1));
}
.border-border\\/60 {
  border-color: rgb(227 233 242 / 0.6);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/80 {
  border-color: rgb(229 231 235 / 0.8);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
}
.border-primary\\/20 {
  border-color: rgb(17 69 152 / 0.2);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.\\!bg-card\\/15 {
  background-color: rgb(255 255 255 / 0.15) !important;
}
.\\!bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(17 69 152 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#114598\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 69 152 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#124699\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 70 153 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#16A34A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CFF7D3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(207 247 211 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDF4FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 244 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EFF6FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0FDF4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F68122\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 129 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-accent {
  --tw-bg-opacity: 1;
  background-color: rgb(246 129 34 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: rgb(247 249 252 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/25 {
  background-color: rgb(0 0 0 / 0.25);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/75 {
  background-color: rgb(0 0 0 / 0.75);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/60 {
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-50\\/70 {
  background-color: rgb(239 246 255 / 0.7);
}
.bg-card {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40 {
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/50 {
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-foreground\\/60 {
  background-color: rgb(20 33 61 / 0.6);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}
.bg-muted\\/20 {
  background-color: rgb(241 246 253 / 0.2);
}
.bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity, 1));
}
.bg-neutral-50\\/70 {
  background-color: rgb(250 250 250 / 0.7);
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(17 69 152 / var(--tw-bg-opacity, 1));
}
.bg-primary\\/10 {
  background-color: rgb(17 69 152 / 0.1);
}
.bg-primary\\/5 {
  background-color: rgb(17 69 152 / 0.05);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(43 99 184 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#114598\\] {
  --tw-gradient-from: #114598 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 69 152 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary {
  --tw-gradient-from: #114598 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 69 152 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-tertiary {
  --tw-gradient-to: rgb(43 99 184 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #2B63B8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#2563EB\\] {
  --tw-gradient-to: #2563EB var(--tw-gradient-to-position);
}
.to-accent {
  --tw-gradient-to: #F68122 var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-center {
  background-position: center;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pr-12 {
  padding-right: 3rem !important;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pe-2 {
  padding-inline-end: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.align-bottom {
  vertical-align: bottom;
}
.font-heading {
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
}
.font-mono {
  font-family: JetBrains Mono, ui-monospace, monospace;
}
.font-sans {
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.15em\\] {
  letter-spacing: 0.15em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#114598\\] {
  --tw-text-opacity: 1;
  color: rgb(17 69 152 / var(--tw-text-opacity, 1));
}
.text-\\[\\#124699\\] {
  --tw-text-opacity: 1;
  color: rgb(18 70 153 / var(--tw-text-opacity, 1));
}
.text-\\[\\#15803D\\] {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-\\[\\#166534\\] {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-\\[\\#204278\\] {
  --tw-text-opacity: 1;
  color: rgb(32 66 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F68122\\] {
  --tw-text-opacity: 1;
  color: rgb(246 129 34 / var(--tw-text-opacity, 1));
}
.text-accent {
  --tw-text-opacity: 1;
  color: rgb(246 129 34 / var(--tw-text-opacity, 1));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-foreground {
  --tw-text-opacity: 1;
  color: rgb(20 33 61 / var(--tw-text-opacity, 1));
}
.text-foreground\\/80 {
  color: rgb(20 33 61 / 0.8);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-muted-foreground {
  --tw-text-opacity: 1;
  color: rgb(91 101 119 / var(--tw-text-opacity, 1));
}
.text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.text-neutral-800 {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(17 69 152 / var(--tw-text-opacity, 1));
}
.text-primary\\/70 {
  color: rgb(17 69 152 / 0.7);
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground {
  --tw-text-opacity: 1;
  color: rgb(20 33 61 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.placeholder-white\\/50::placeholder {
  color: rgb(255 255 255 / 0.5);
}
.accent-emerald-600 {
  accent-color: #059669;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-theme {
  --tw-shadow: 0 10px 30px -8px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 10px 30px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-secondary {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 246 253 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\[animation-delay\\:-0\\.15s\\] {
  animation-delay: -0.15s;
}
.\\[animation-delay\\:-0\\.3s\\] {
  animation-delay: -0.3s;
}

:root {
  --background: #f7f9fc;
  --foreground: #14213d;
  --primary: #114598;
  --primary-foreground: #ffffff;
  --tertiary: #2b63b8;
  --secondary: #f1f6fd;
  --muted: #f1f6fd;
  --muted-foreground: #5b6577;
  --accent: #f68122;
  --card: #ffffff;
  --border: #e3e9f2;
  --input: #e3e9f2;
  --ring: #114598;
  --radius: 1.125rem;
}

html {
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
  background-color: var(--background);
  color: var(--foreground);
  margin: 0;
}

p {
  margin-bottom: 0;
}

.font-heading {
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
}

.brand-gradient {
  background: linear-gradient(135deg, var(--primary), var(--accent));
}

.card-gradient-strip {
  background: linear-gradient(
    to right,
    var(--primary),
    var(--tertiary),
    var(--accent)
  );
}

.shadow-theme {
  box-shadow: 0 10px 30px -8px rgba(15, 23, 42, 0.12);
}

/* ---------- shared atoms (design-only, responsive) ---------- */

.ql-container {
  height: calc(100% - 50px) !important;
}
@media screen and (max-width: 708px) {
  .ql-container {
    height: calc(100% - 90px) !important;
  }
}

@media screen and (max-width: 480px) {
  .ql-container {
    height: calc(100% - 100px) !important;
  }
}
@media screen and (max-width: 410px) {
  .ql-container {
    height: calc(100% - 120px) !important;
  }
}
@media screen and (max-width: 600px) {
  .ant-picker-panel-container {
    max-width: calc(100vw - 3rem);
    overflow-x: auto !important;
  }
}
.pagination-link a {
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  width: 100%;
  height: 100%;
  text-decoration: none;
  cursor: pointer;
}
.pagination-link a:hover {
  color: black;
}
.active-pagination-link a:hover {
  color: white;
}
.active-pagination-link a {
  color: white;
}

.loader {
  border: 3px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: spin89345 0.75s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

.bef-btn-primary .loader {
  border: 3px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
}

@keyframes spin89345 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-arrows {
  appearance: textfield;
  -moz-appearance: textfield;
}

.PhoneInputInput {
  outline: none;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #fff;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #114598;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #f68122;
}

.ant-select-selector {
  border-radius: 1.125rem !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1)) !important;
  padding-inline-end: 2rem !important;
}

.ant-select-selector:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1)) !important;
}

.ant-select-selector:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1)) !important;
}

.ant-select-selector {
  border-color: var(--border) !important;
}

.antForm .ant-select-selector {
  width: 100% !important;
}

.variation-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  border: 1px solid #E2E8F0;
  border-radius: 14px;
  background: #FFFFFF;
  margin: 1.5rem 0;
}
.variation-table th {
  background: #114598;
  color: #FFFFFF;
  padding: 14px 16px;
  text-align: left;
  font-size: 14px;
  font-weight: 700;
}
.variation-table td {
  padding: 14px 16px;
  border-top: 1px solid #E2E8F0;
  font-size: 14px;
  line-height: 1.55;
  color: #1E293B;
}
.variation-table tr:nth-child(even) td {
  background: #EFF6FF;
}

.content-image-card {
  overflow: hidden;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  background: #FFFFFF;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.07);
  margin: 2rem 0;
}
.content-image-card img {
  width: 100%;
  display: block;
  aspect-ratio: 16/7;
  object-fit: cover;
}
.content-image-card .image-caption {
  padding: 14px 16px;
  font-size: 13px;
  color: #64748B;
  background: #F8FAFC;
  border-top: 1px solid #E2E8F0;
}

.ad-banner {
  position: relative;
  display: flex;
  min-height: 130px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  overflow: hidden;
  border-radius: 16px;
  background: linear-gradient(135deg, #114598, #1e5fc9);
  padding: 26px 30px;
  color: #FFFFFF;
  box-shadow: 0 10px 30px rgba(17, 69, 152, 0.18);
  margin: 2rem 0;
}
.ad-banner:after {
  content: "";
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 999px;
  border: 35px solid rgba(255, 255, 255, 0.10);
  right: -55px;
  top: -80px;
  pointer-events: none;
}
.ad-banner .ad-copy {
  position: relative;
  z-index: 1;
  max-width: 650px;
}
.ad-banner .ad-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  opacity: 0.85;
  color: #FFFFFF;
}
.ad-banner h3 {
  margin: 6px 0 5px;
  font-size: 20px;
  font-weight: 800;
  color: #FFFFFF;
}
.ad-banner p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  opacity: 0.95;
  color: #FFFFFF;
}
.ad-banner a {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  border-radius: 999px;
  background: #FFFFFF;
  color: #114598 !important;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
}
.ad-banner a:hover {
  background: #F8FAFC;
  transform: translateY(-1px);
}

.mcq-box {
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  background: #FFFFFF;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  margin: 2rem 0;
}
.mcq-question {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #E2E8F0;
}
.mcq-question:first-of-type {
  margin-top: 8px;
  padding-top: 0;
  border-top: 0;
}
.mcq-question p {
  font-weight: 700;
  line-height: 1.55;
  color: #0F172A;
  margin-bottom: 10px;
}
.mcq-option {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
  color: #334155;
  transition: all 0.2s ease;
}
.mcq-option:hover {
  border-color: #114598;
  background: #EFF6FF;
}
.mcq-result {
  margin-top: 18px;
  border-radius: 10px;
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 700;
  color: #1E40AF;
}

@media (max-width: 640px) {
  .ad-banner {
    display: block;
    padding: 20px;
  }
  .ad-banner a {
    margin-top: 14px;
  }
  .variation-table {
    font-size: 12px;
  }
  .variation-table th,
  .variation-table td {
    padding: 10px;
  }
}

.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:h-3\\.5::before {
  content: var(--tw-content);
  height: 0.875rem;
}

.before\\:w-3\\.5::before {
  content: var(--tw-content);
  width: 0.875rem;
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-transparent::before {
  content: var(--tw-content);
  background-color: transparent;
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:z-\\[2\\]::after {
  content: var(--tw-content);
  z-index: 2;
}

.after\\:-mt-\\[0\\.1875rem\\]::after {
  content: var(--tw-content);
  margin-top: -0.1875rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border-none::after {
  content: var(--tw-content);
  border-style: none;
}

.after\\:bg-neutral-100::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.after\\:shadow-\\[0_0px_3px_0_rgb\\(0_0_0_\\/_7\\%\\)\\2c _0_2px_2px_0_rgb\\(0_0_0_\\/_4\\%\\)\\]::after {
  content: var(--tw-content);
  --tw-shadow: 0 0px 3px 0 rgb(0 0 0 / 7%), 0 2px 2px 0 rgb(0 0 0 / 4%);
  --tw-shadow-colored: 0 0px 3px 0 var(--tw-shadow-color), 0 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.after\\:transition-\\[background-color_0\\.2s\\2c transform_0\\.2s\\]::after {
  content: var(--tw-content);
  transition-property: background-color 0.2s,transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.checked\\:bg-secondary:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}

.checked\\:after\\:absolute:checked::after {
  content: var(--tw-content);
  position: absolute;
}

.checked\\:after\\:z-\\[2\\]:checked::after {
  content: var(--tw-content);
  z-index: 2;
}

.checked\\:after\\:-mt-\\[3px\\]:checked::after {
  content: var(--tw-content);
  margin-top: -3px;
}

.checked\\:after\\:ml-\\[1\\.0625rem\\]:checked::after {
  content: var(--tw-content);
  margin-left: 1.0625rem;
}

.checked\\:after\\:h-5:checked::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.checked\\:after\\:w-5:checked::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.checked\\:after\\:rounded-full:checked::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.checked\\:after\\:border-none:checked::after {
  content: var(--tw-content);
  border-style: none;
}

.checked\\:after\\:bg-primary:checked::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(17 69 152 / var(--tw-bg-opacity, 1));
}

.checked\\:after\\:shadow-\\[0_3px_1px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\2c _0_2px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.14\\)\\2c _0_1px_5px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\]:checked::after {
  content: var(--tw-content);
  --tw-shadow: 0 3px 1px -2px rgba(0,0,0,0.2), 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12);
  --tw-shadow-colored: 0 3px 1px -2px var(--tw-shadow-color), 0 2px 2px 0 var(--tw-shadow-color), 0 1px 5px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.checked\\:after\\:transition-\\[background-color_0\\.2s\\2c transform_0\\.2s\\]:checked::after {
  content: var(--tw-content);
  transition-property: background-color 0.2s,transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.checked\\:after\\:content-\\[\\'\\'\\]:checked::after {
  --tw-content: '';
  content: var(--tw-content);
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:border-\\[\\#114598\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#124699\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(18 70 153 / var(--tw-border-opacity, 1));
}

.hover\\:border-accent:hover {
  --tw-border-opacity: 1;
  border-color: rgb(246 129 34 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
}

.hover\\:\\!bg-accent:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 129 34 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#0d3678\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(13 54 120 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0e3575\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 53 117 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F48224\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 130 36 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F68122\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 129 34 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-accent:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 129 34 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-50\\/50:hover {
  background-color: rgb(250 250 250 / 0.5);
}

.hover\\:bg-primary\\/20:hover {
  background-color: rgb(17 69 152 / 0.2);
}

.hover\\:bg-primary\\/90:hover {
  background-color: rgb(17 69 152 / 0.9);
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/80:hover {
  background-color: rgb(239 68 68 / 0.8);
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary\\/60:hover {
  background-color: rgb(241 246 253 / 0.6);
}

.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-opacity-90:hover {
  --tw-bg-opacity: 0.9;
}

.hover\\:from-\\[\\#F68122\\]:hover {
  --tw-gradient-from: #F68122 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(246 129 34 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-amber-500:hover {
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}

.hover\\:\\!text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#114598\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(17 69 152 / var(--tw-text-opacity, 1));
}

.hover\\:text-accent:hover {
  --tw-text-opacity: 1;
  color: rgb(246 129 34 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(20 33 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-orange-600:hover {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(17 69 152 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary\\/80:hover {
  color: rgb(17 69 152 / 0.8);
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow-theme:hover {
  --tw-shadow: 0 10px 30px -8px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 10px 30px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-\\[\\#EB8844\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(235 136 68 / var(--tw-border-opacity, 1));
}

.focus\\:border-emerald-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:text-slate-900:focus {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#124699\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(18 70 153 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 69 152 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus\\:before\\:transition-\\[box-shadow_0\\.2s\\2c transform_0\\.2s\\]:focus::before {
  content: var(--tw-content);
  transition-property: box-shadow 0.2s,transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.focus\\:after\\:absolute:focus::after {
  content: var(--tw-content);
  position: absolute;
}

.focus\\:after\\:z-\\[1\\]:focus::after {
  content: var(--tw-content);
  z-index: 1;
}

.focus\\:after\\:block:focus::after {
  content: var(--tw-content);
  display: block;
}

.focus\\:after\\:h-5:focus::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.focus\\:after\\:w-5:focus::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.focus\\:after\\:rounded-full:focus::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.focus\\:after\\:content-\\[\\'\\'\\]:focus::after {
  --tw-content: '';
  content: var(--tw-content);
}

.checked\\:focus\\:border-primary:focus:checked {
  --tw-border-opacity: 1;
  border-color: rgb(17 69 152 / var(--tw-border-opacity, 1));
}

.checked\\:focus\\:bg-secondary:focus:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}

.checked\\:focus\\:before\\:ml-\\[1\\.0625rem\\]:focus:checked::before {
  content: var(--tw-content);
  margin-left: 1.0625rem;
}

.active\\:bg-secondary:active {
  --tw-bg-opacity: 1;
  background-color: rgb(241 246 253 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-\\[\\#124699\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 70 153 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-\\[\\#F48224\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 130 36 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:text-\\[\\#124699\\] {
  --tw-text-opacity: 1;
  color: rgb(18 70 153 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media not all and (min-width: 640px) {

  .max-sm\\:w-full {
    width: 100%;
  }

  .max-sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .max-sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 640px) {

  .sm\\:order-1 {
    order: 1;
  }

  .sm\\:order-2 {
    order: 2;
  }

  .sm\\:-m-5 {
    margin: -1.25rem;
  }

  .sm\\:-m-6 {
    margin: -1.5rem;
  }

  .sm\\:-m-8 {
    margin: -2rem;
  }

  .sm\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }

  .sm\\:-mt-6 {
    margin-top: -1.5rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-4 {
    margin-left: 1rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:mt-7 {
    margin-top: 1.75rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-\\[calc\\(100dvh-8rem\\)\\] {
    height: calc(100dvh - 8rem);
  }

  .sm\\:h-screen {
    height: 100vh;
  }

  .sm\\:max-h-\\[90dvh\\] {
    max-height: 90dvh;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-56 {
    width: 14rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-\\[120px\\] {
    width: 120px;
  }

  .sm\\:w-\\[150px\\] {
    width: 150px;
  }

  .sm\\:w-\\[16rem\\] {
    width: 16rem;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:w-\\[280px\\] {
    width: 280px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:min-w-\\[180px\\] {
    min-width: 180px;
  }

  .sm\\:min-w-\\[220px\\] {
    min-width: 220px;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:pl-4 {
    padding-left: 1rem;
  }

  .sm\\:ps-4 {
    padding-inline-start: 1rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:align-middle {
    vertical-align: middle;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {

  .md\\:top-20 {
    top: 5rem;
  }

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:-m-6 {
    margin: -1.5rem;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-20 {
    margin-top: 5rem;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-11 {
    height: 2.75rem;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:max-h-\\[calc\\(100vh-5rem\\)\\] {
    max-height: calc(100vh - 5rem);
  }

  .md\\:min-h-\\[calc\\(100vh-5rem\\)\\] {
    min-height: calc(100vh - 5rem);
  }

  .md\\:w-10 {
    width: 2.5rem;
  }

  .md\\:w-11 {
    width: 2.75rem;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-2xl {
    max-width: 42rem;
  }

  .md\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-16 {
    gap: 4rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:top-4 {
    top: 1rem;
  }

  .lg\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:ml-72 {
    margin-left: 18rem;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[calc\\(100dvh-7rem\\)\\] {
    height: calc(100dvh - 7rem);
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:flex-none {
    flex: none;
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-2 {
    gap: 0.5rem;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:opacity-100 {
    opacity: 1;
  }
}

@media (min-width: 1280px) {

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:gap-3 {
    gap: 0.75rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:gap-6 {
    gap: 1.5rem;
  }
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-0::-webkit-scrollbar {
  width: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,wDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,oDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AA6DV;EAAA,gBAA8D;EAA9D,uBAA8D;EAA9D,iBAA8D;EAA9D,kBAA8D;EAA9D,4DAA8D;EAA9D,iDAA8D;EAA9D,4DAA8D;EAA9D,uGAA8D;EAA9D,mDAA8D;IAC9D;AAD8D;AAI9D;EAAA,oBAAiM;EAAjM,mBAAiM;EAAjM,mBAAiM;EAAjM,uBAAiM;EAAjM,WAAiM;EAAjM,uBAAiM;EAAjM,iBAAiM;EAAjM,sBAAiM;EAAjM,0DAAiM;EAAjM,kBAAiM;EAAjM,0DAAiM;EAAjM,kBAAiM;EAAjM,mBAAiM;EAAjM,kBAAiM;EAAjM,iBAAiM;EAAjM,gBAAiM;EAAjM,oBAAiM;EAAjM,mDAAiM;EAAjM,wBAAiM;EAAjM,wDAAiM;EAAjM;AAAiM;AAAjM;;EAAA;IAAA,qBAAiM;IAAjM,sBAAiM;IAAjM,mBAAiM;IAAjM;EAAiM;AAAA;AAGjM;EAAA,2BAAkC;EAAlC,+LAAkC;EAAlC,oBAAkC;EAAlC,mDAAkC;IAClC,yBAAyB;IACzB;AAFkC;AAMlC;;EAAA,oBAAuE;EAAvE,eAAuE;EAAvE,mBAAuE;EAAvE,YAAuE;IACvE,2CAA2C;IAC3C,uCAAuC;IACvC;AAHuE;AAMvE;EAAA,oBAA+K;EAA/K,mBAA+K;EAA/K,mBAA+K;EAA/K,uBAA+K;EAA/K,WAA+K;EAA/K,uBAA+K;EAA/K,kBAA+K;EAA/K,4DAA+K;EAA/K,kBAA+K;EAA/K,mBAA+K;EAA/K,kBAA+K;EAA/K,iBAA+K;EAA/K,gBAA+K;EAA/K,oBAA+K;EAA/K,iDAA+K;EAA/K,wBAA+K;EAA/K,wDAA+K;EAA/K;AAA+K;AAA/K;;EAAA;IAAA,qBAA+K;IAA/K,sBAA+K;IAA/K,mBAA+K;IAA/K;EAA+K;AAAA;AAG/K;EAAA,2BAAuB;EAAvB;AAAuB;AAGvB;EAAA,WAAqH;EAArH,uBAAqH;EAArH,iBAAqH;EAArH,kBAAqH;EAArH,4DAAqH;EAArH,kBAAqH;EAArH,mBAAqH;EAArH,qBAAqH;EAArH,wBAAqH;EAArH,mBAAqH;EAArH,oBAAqH;EAArH,oBAAqH;EAArH,gDAAqH;EAArH,8BAAqH;EAArH,mBAAqH;EAArH,wBAAqH;EAArH,wDAAqH;EAArH,0BAAqH;IACrH;AADqH;AAGvH;IACE,4BAA4B;IAC5B,6CAA6C;EAC/C;AAEE;EAAA,sBAAuD;EAAvD,cAAuD;EAAvD,mBAAuD;EAAvD,oBAAuD;EAAvD,gBAAuD;EAAvD,oBAAuD;EAAvD;AAAuD;AAGvD;EAAA,oBAAkI;EAAlI,mBAAkI;EAAlI,qBAAkI;EAAlI,kBAAkI;EAAlI,4DAAkI;EAAlI,oBAAkI;EAAlI,qBAAkI;EAAlI,oBAAkI;EAAlI,uBAAkI;EAAlI,cAAkI;EAAlI,gBAAkI;EAAlI,yBAAkI;EAAlI,uBAAkI;EAAlI,oBAAkI;EAAlI;AAAkI;AAGlI;EAAA,WAA6B;EAA7B;AAA6B;AAlGjC;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;EACnC,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,mDAAmD;AACrD;;AAEA,iEAAiE;;AA+CjE;EACE,oCAAoC;AACtC;AACA;EACE;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAGE;EAAA,kCAAqF;EAArF,iCAAqF;EAArF,uEAAqF;EAArF;AAAqF;;AAArF;EAAA,iCAAqF;EAArF;AAAqF;;AAArF;EAAA,iCAAqF;EAArF;AAAqF;;AADvF;EAEE,sCAAsC;AACxC;;AAGE;EAAA;AAAc;;AAGhB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;EAClB,cAAc;EACd,+CAA+C;EAC/C,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,4CAA4C;EAC5C,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;AACF;;AAxZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,gBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,qEAyZA;EAzZA,2FAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,yDAyZA;EAzZA,wDAyZA;EAzZA;AAyZA;;AAzZA;EAAA,gBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,uGAyZA;EAzZA,kIAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,yDAyZA;EAzZA,wDAyZA;EAzZA;AAyZA;;AAzZA;EAAA,gBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,6BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,4DAyZA;EAzZA,oEAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,+BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,iDAyZA;EAzZA,4DAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,8BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,2GAyZA;EAzZA,yGAyZA;EAzZA;AAyZA;;AAzZA;EAAA,2GAyZA;EAzZA,yGAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA,mDAyZA;EAzZA,wDAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,gBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,sBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,0BAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA;AAyZA;;AAzZA;EAAA,iBAyZA;EAzZA,iBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,kBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;EAAA,oBAyZA;EAzZA;AAyZA;;AAzZA;;EAAA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;AAAA;;AAzZA;;EAAA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,oBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,gBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,iBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,gBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,gBAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,uBAyZA;IAzZA,oDAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,oBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,oBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,qBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,oBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,iBAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,iBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;AAAA;;AAzZA;;EAAA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,gBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,oBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,iBAyZA;IAzZA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,eAyZA;IAzZA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;AAAA;;AAzZA;;EAAA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,qBAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,kBAyZA;IAzZA;EAyZA;;EAzZA;IAAA;EAyZA;AAAA;;AAzZA;;EAAA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;;EAzZA;IAAA,mBAyZA;IAzZA;EAyZA;AAAA;;AAzZA;;EAAA;IAAA;EAyZA;;EAzZA;IAAA;EAyZA;AAAA;;AAzZA;EAAA;AAyZA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --background: #f7f9fc;\n  --foreground: #14213d;\n  --primary: #114598;\n  --primary-foreground: #ffffff;\n  --tertiary: #2b63b8;\n  --secondary: #f1f6fd;\n  --muted: #f1f6fd;\n  --muted-foreground: #5b6577;\n  --accent: #f68122;\n  --card: #ffffff;\n  --border: #e3e9f2;\n  --input: #e3e9f2;\n  --ring: #114598;\n  --radius: 1.125rem;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  font-family: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  background-color: var(--background);\n  color: var(--foreground);\n  margin: 0;\n}\n\np {\n  margin-bottom: 0;\n}\n\n.font-heading {\n  font-family: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n}\n\n.brand-gradient {\n  background: linear-gradient(135deg, var(--primary), var(--accent));\n}\n\n.card-gradient-strip {\n  background: linear-gradient(\n    to right,\n    var(--primary),\n    var(--tertiary),\n    var(--accent)\n  );\n}\n\n.shadow-theme {\n  box-shadow: 0 10px 30px -8px rgba(15, 23, 42, 0.12);\n}\n\n/* ---------- shared atoms (design-only, responsive) ---------- */\n\n@layer components {\n  .bef-card {\n    @apply overflow-hidden rounded-xl border bg-white shadow-theme;\n    border-color: var(--border);\n  }\n  .bef-btn-primary {\n    @apply inline-flex min-h-[2.75rem] items-center justify-center gap-2 rounded-xl border border-primary bg-primary px-4 text-xs font-bold text-white transition-all duration-300 sm:px-5 sm:text-sm;\n  }\n  .bef-btn-primary:hover:not(:disabled) {\n    @apply -translate-y-0.5 text-white;\n    background-color: #0d3678;\n    border-color: #0d3678;\n  }\n  .bef-btn-primary:disabled,\n  .bef-btn-primary[disabled] {\n    @apply opacity-80 cursor-not-allowed pointer-events-none transform-none;\n    background-color: var(--primary) !important;\n    border-color: var(--primary) !important;\n    color: #ffffff !important;\n  }\n  .bef-btn-secondary {\n    @apply inline-flex min-h-[2.75rem] items-center justify-center gap-2 rounded-xl bg-secondary px-4 text-xs font-bold text-primary transition-all duration-300 sm:px-5 sm:text-sm;\n  }\n  .bef-btn-secondary:hover {\n    @apply -translate-y-0.5;\n  }\n  .bef-input {\n    @apply w-full rounded-xl border bg-white px-4 py-2.5 text-sm text-foreground outline-none transition-all duration-300;\n    border-color: var(--border);\n  }\n  .bef-input:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(17, 69, 152, 0.12);\n  }\n  .bef-label {\n    @apply mb-1 block text-sm font-semibold text-foreground;\n  }\n  .bef-badge {\n    @apply inline-flex items-center rounded-full bg-secondary px-2 py-1 text-[9px] font-extrabold uppercase tracking-wide text-primary;\n  }\n  .bef-table-wrap {\n    @apply w-full overflow-x-auto;\n  }\n}\n\n.ql-container {\n  height: calc(100% - 50px) !important;\n}\n@media screen and (max-width: 708px) {\n  .ql-container {\n    height: calc(100% - 90px) !important;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .ql-container {\n    height: calc(100% - 100px) !important;\n  }\n}\n@media screen and (max-width: 410px) {\n  .ql-container {\n    height: calc(100% - 120px) !important;\n  }\n}\n@media screen and (max-width: 600px) {\n  .ant-picker-panel-container {\n    max-width: calc(100vw - 3rem);\n    overflow-x: auto !important;\n  }\n}\n.pagination-link a {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: black;\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n  cursor: pointer;\n}\n.pagination-link a:hover {\n  color: black;\n}\n.active-pagination-link a:hover {\n  color: white;\n}\n.active-pagination-link a {\n  color: white;\n}\n\n.loader {\n  border: 3px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  animation: spin89345 0.75s linear infinite;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.bef-btn-primary .loader {\n  border: 3px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #ffffff;\n}\n\n@keyframes spin89345 {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.no-arrows::-webkit-inner-spin-button,\n.no-arrows::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.no-arrows {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n.PhoneInputInput {\n  outline: none;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 5px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px #fff;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #114598;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #f68122;\n}\n\n.ant-select-selector {\n  @apply !rounded-xl !border-gray-300 hover:!border-primary focus:!border-primary !pe-8;\n  border-color: var(--border) !important;\n}\n\n.antForm .ant-select-selector {\n  @apply !w-full;\n}\n\n.variation-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  overflow: hidden;\n  border: 1px solid #E2E8F0;\n  border-radius: 14px;\n  background: #FFFFFF;\n  margin: 1.5rem 0;\n}\n.variation-table th {\n  background: #114598;\n  color: #FFFFFF;\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 700;\n}\n.variation-table td {\n  padding: 14px 16px;\n  border-top: 1px solid #E2E8F0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #1E293B;\n}\n.variation-table tr:nth-child(even) td {\n  background: #EFF6FF;\n}\n\n.content-image-card {\n  overflow: hidden;\n  border: 1px solid #E2E8F0;\n  border-radius: 16px;\n  background: #FFFFFF;\n  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.07);\n  margin: 2rem 0;\n}\n.content-image-card img {\n  width: 100%;\n  display: block;\n  aspect-ratio: 16/7;\n  object-fit: cover;\n}\n.content-image-card .image-caption {\n  padding: 14px 16px;\n  font-size: 13px;\n  color: #64748B;\n  background: #F8FAFC;\n  border-top: 1px solid #E2E8F0;\n}\n\n.ad-banner {\n  position: relative;\n  display: flex;\n  min-height: 130px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  overflow: hidden;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #114598, #1e5fc9);\n  padding: 26px 30px;\n  color: #FFFFFF;\n  box-shadow: 0 10px 30px rgba(17, 69, 152, 0.18);\n  margin: 2rem 0;\n}\n.ad-banner:after {\n  content: \"\";\n  position: absolute;\n  width: 180px;\n  height: 180px;\n  border-radius: 999px;\n  border: 35px solid rgba(255, 255, 255, 0.10);\n  right: -55px;\n  top: -80px;\n  pointer-events: none;\n}\n.ad-banner .ad-copy {\n  position: relative;\n  z-index: 1;\n  max-width: 650px;\n}\n.ad-banner .ad-label {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  opacity: 0.85;\n  color: #FFFFFF;\n}\n.ad-banner h3 {\n  margin: 6px 0 5px;\n  font-size: 20px;\n  font-weight: 800;\n  color: #FFFFFF;\n}\n.ad-banner p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  opacity: 0.95;\n  color: #FFFFFF;\n}\n.ad-banner a {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  border-radius: 999px;\n  background: #FFFFFF;\n  color: #114598 !important;\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 800;\n  text-decoration: none !important;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\n  transition: all 0.2s ease;\n}\n.ad-banner a:hover {\n  background: #F8FAFC;\n  transform: translateY(-1px);\n}\n\n.mcq-box {\n  border: 1px solid #E2E8F0;\n  border-radius: 16px;\n  background: #FFFFFF;\n  padding: 24px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);\n  margin: 2rem 0;\n}\n.mcq-question {\n  margin-top: 18px;\n  padding-top: 18px;\n  border-top: 1px solid #E2E8F0;\n}\n.mcq-question:first-of-type {\n  margin-top: 8px;\n  padding-top: 0;\n  border-top: 0;\n}\n.mcq-question p {\n  font-weight: 700;\n  line-height: 1.55;\n  color: #0F172A;\n  margin-bottom: 10px;\n}\n.mcq-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  padding: 10px 14px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #334155;\n  transition: all 0.2s ease;\n}\n.mcq-option:hover {\n  border-color: #114598;\n  background: #EFF6FF;\n}\n.mcq-result {\n  margin-top: 18px;\n  border-radius: 10px;\n  background: #EFF6FF;\n  border: 1px solid #BFDBFE;\n  padding: 14px 16px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #1E40AF;\n}\n\n@media (max-width: 640px) {\n  .ad-banner {\n    display: block;\n    padding: 20px;\n  }\n  .ad-banner a {\n    margin-top: 14px;\n  }\n  .variation-table {\n    font-size: 12px;\n  }\n  .variation-table th,\n  .variation-table td {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
